module.exports = __webpack_public_path__ + "img/info-coupon.d292f4cf.svg";